import { useMutation, useQueryClient } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";
import toast from "react-hot-toast";
import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";

export const useAddFilter = () => {
  const queryClient = useQueryClient(); // Access the query client
  const { userDetails } = useContext(UserContext);

  const mutation = useMutation({
    mutationFn: async ({ location, faultInfo }) => {
      // Check for token inside the mutation function
      if (!userDetails?.userWiMuleToken) {
        throw new Error("Authentication token is missing.");
      }

      const setTime = new Date().toISOString().split("T")[0]; // Set time in YYYY-MM-DD format
      const userId = userDetails.userId;

      const endpoint = `${WiMuleSQL}/api/ActiveFaults/AddFilter?location=${encodeURIComponent(
        location
      )}&faultInfo=${encodeURIComponent(
        faultInfo
      )}&setTime=${setTime}&userID=${userId}`;

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userDetails.userWiMuleToken}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        throw new Error(error.message);
      }
    },
    onSuccess: (data) => {
      // Invalidate the relevant queries to refresh data
      queryClient.invalidateQueries(["getActiveFaults"]);
      queryClient.invalidateQueries(["getFilterList"]);
      // Handle success
      toast.success(data.message || "Filter added successfully");
    },
    onError: (error) => {
      // Handle error
      toast.error(error.message || "Failed to add filter");
    },
  });

  return mutation;
};
